import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../Layout/header";
import { Aside } from "../Layout/Aside.jsx";
import "./shell.css";

const AUTH_PATHS = new Set([
  "/",
  "/login",
  "/register",
  "/forgot-password",
  "/registrationSuccessful",

]);

export function AppLayout() {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") {
        setMobileOpen(false);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const isAuthPath =
    AUTH_PATHS.has(location.pathname) ||
    location.pathname.startsWith("/create-password/");

  if (isAuthPath) {
    return null;
  }

  const sidebar = (
    <Aside
      collapsed={collapsed}
      setCollapsed={setCollapsed}
      onNavigate={() => setMobileOpen(false)}
    />
  );

  return (
    <div className="crm-shell">
      <div className="crm-shell__desktop-aside">{sidebar}</div>

      {mobileOpen && (
        <div className="crm-shell__mobile-backdrop">
          <div
            className="crm-shell__mobile-overlay"
            onClick={() => setMobileOpen(false)}
            aria-label="Close menu"
          />
          <div className="crm-shell__mobile-panel">{sidebar}</div>
        </div>
      )}

      <div className="crm-shell__main-col">
        <Header
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          onOpenMobile={() => setMobileOpen(true)}
        />
        <main className="crm-shell__content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
